<!-- reset-password.component.html -->
<section class="singUp-area section-py-120">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-6 col-lg-8">
        <div class="singUp-wrap">
          <h2 class="title">Reset Password</h2>

          <div *ngIf="tokenExpired" class="alert alert-danger">
            This password reset link has expired or is invalid. Please request a
            new password reset.
          </div>

          <div *ngIf="!tokenExpired">
            <p>Enter your new password below.</p>
            <div class="account__divider"></div>

            <form [formGroup]="resetForm" novalidate class="account__form">
              <div class="form-grp">
                <label class="inline"
                  >New Password <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{ 'has-error': f['password'].errors && submitted }"
                >
                  <input
                    type="password"
                    class="form-control"
                    formControlName="password"
                  />
                  <div
                    *ngIf="f['password'].errors && submitted"
                    class="text-danger"
                  >
                    <div *ngIf="f['password'].errors['required']">
                      Password is required
                    </div>
                    <div *ngIf="f['password'].errors['minlength']">
                      Password must be at least 8 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-grp">
                <label class="inline"
                  >Confirm Password <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{
                    'has-error': f['confirmPassword'].errors && submitted,
                  }"
                >
                  <input
                    type="password"
                    class="form-control"
                    formControlName="confirmPassword"
                  />
                  <div
                    *ngIf="f['confirmPassword'].errors && submitted"
                    class="text-danger"
                  >
                    <div *ngIf="f['confirmPassword'].errors['required']">
                      Confirm Password is required
                    </div>
                    <div *ngIf="f['confirmPassword'].errors['mustMatch']">
                      Passwords must match
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <button class="btn btn-two arrow-btn" (click)="onSubmit()">
                Reset Password
                <img
                  src="assets/img/icons/right_arrow.svg"
                  alt="img"
                  class="injectable"
                />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
